export default function initBackToTop(): void {
  const button = document.getElementById('back-to-top') as HTMLButtonElement | null

  if (!button) {
    return
  }

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  })
}
